import { Group, Text } from '@mantine/core';

import { useTranslation } from 'react-i18next';

import { Avatar } from '../../../../../../../../../shared/components/UI/Avatar/Avatar';

import AssistantAvatar from '../assets/AssistantAvatar.svg?react';

export function LoaderMessage() {
  const { t } = useTranslation('bidResponse');
  return (
    <Group noWrap spacing="02">
      <Avatar
        component={AssistantAvatar}
        sx={{
          width: 24,
          height: 24,
          display: 'inline-block',
          animation: 'bounce 1.2s infinite',
          '@keyframes bounce': {
            '0%, 100%': { transform: 'translateY(-4px)' },
            '50%': { transform: 'translateY(4px)' },
          },
        }}
      />
      <Text
        c="gray.9"
        size="sm"
        fw={400}
        sx={{
          '@keyframes fade': {
            '0%, 80%, 100%': { opacity: 0 },
            '40%': { opacity: 1 },
          },
        }}
      >
        {t('assistant.searchingForExtracts')}
        <AnimatedDots />
      </Text>
    </Group>
  );
}

function AnimatedDots() {
  return (
    <span
      aria-label="loading"
      style={{ display: 'inline-block', width: 20, textAlign: 'left' }}
    >
      <span
        style={{
          animation: 'fade 2s infinite',
          animationDelay: '0s',
        }}
      >
        .
      </span>
      <span
        style={{
          animation: 'fade 2s infinite',
          animationDelay: '0.66s',
        }}
      >
        .
      </span>
      <span
        style={{
          animation: 'fade 2s infinite',
          animationDelay: '1s',
        }}
      >
        .
      </span>
    </span>
  );
}
